export enum SaleItemKindEnum {
  SERVICE = 'SERVICE',
  PACKAGE = 'PACKAGE',
}
